(function () {
    'use strict';

    angular
        .module('BCMControllers')
        .directive('biaContactDetails', directive);

    function directive() {
        return {
            restrict: 'A',
            template:
            '<div class="text-center margin-xl-v">\n' +
            '    For any Business Continuity related questions, please contact' +
            '    <a href="mailto:continuity@investpsp.ca" class="gov-link">continuity@investpsp.ca</a>\n' +
            '</div>'
        };
    }
})();